import { render, staticRenderFns } from "./comExamOther.vue?vue&type=template&id=15c8b4f9&scoped=true"
import script from "./comExamOther.vue?vue&type=script&lang=js"
export * from "./comExamOther.vue?vue&type=script&lang=js"
import style0 from "./comExamOther.vue?vue&type=style&index=0&id=15c8b4f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c8b4f9",
  null
  
)

export default component.exports